<!-- --------头部-------- -->
<template>
  <header>
    <!--logo-->
    <div class="logo"
         :title="name"
         @click="toHome()">
      <img :src="logoImg"
           alt="logo">
    </div>
    <!--导航-->
    <Menu mode="horizontal"
          theme="dark"
          :active-name="activeMenu_pc"
          ref="highlight_pc"
          v-show="ifPcShow">
      <div v-for="m in menu"
           :key="m.id">
        <!--如有二级菜单-->
        <div v-if="m.child != null">
          <Submenu :name="m.id">
            <template slot="title">{{m.name}}</template>
            <div v-for="c in m.child"
                 :key="c.id">
              <MenuItem :name="c.id">
              <span @click="toPage(c.route)">{{c.name}}</span>
              </MenuItem>
            </div>
          </Submenu>
        </div>
        <!--一级菜单-->
        <div v-else>
          <MenuItem :name="m.id">
          <span @click="toPage(m.route)">{{m.name}}</span>
          </MenuItem>
        </div>
      </div>
    </Menu>
    <div class="phoneMenu"
         v-show="ifPhoneShow">
      <span class="menuBtn"
            @click="phoneMenu = true">&#xe63c;</span>
      <Drawer v-model="phoneMenu"
              width="288"
              :mask-closable="true"
              :styles="drawerStyles">
        <Menu mode="vertical"
              theme="dark"
              :accordion="isAccordion"
              :active-name="activeMenu_phone"
              ref="highlight_phone">
          <div v-for="m in menu"
               :key="m.id">
            <!--如有二级菜单-->
            <div v-if="m.child != null">
              <Submenu :name="m.id">
                <template slot="title">{{m.name}}</template>
                <div v-for="c in m.child"
                     :key="c.id">
                  <MenuItem :name="c.id">
                  <span @click="toPage(c.route)">{{c.name}}</span>
                  </MenuItem>
                </div>
              </Submenu>
            </div>
            <!--一级菜单-->
            <div v-else>
              <MenuItem :name="m.id">
              <span @click="toPage(m.route)">{{m.name}}</span>
              </MenuItem>
            </div>
          </div>
        </Menu>
      </Drawer>
    </div>
  </header>
</template>

<script>
import store from "../../store";

export default {
  name: "myHeader",
  inject: ['reload'],
  data () {
    return {
      name: '成都天下医森数字科技有限公司',
      logoImg: '/static/images/logo.png',
      activeMenu_pc: 1,
      activeMenu_phone: 1,
      menu: [],
      ifPcShow: '',
      ifPhoneShow: '',
      menuBtnShow: '',
      isAccordion: true,
      phoneMenu: false,
      drawerStyles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        position: 'static'
      }
    }
  },
  mounted () {
    /*菜单显示方式*/
    if (document.body.clientWidth > 768) {
      this.ifPcShow = true;
    } else {
      this.menuBtnShow = true;
      this.ifPhoneShow = true;
    }

    /*菜单init*/
    this.$http.get("../../static/jsonData/menu.json").then(res => {
      // console.log(res.data.content);
      this.menu = res.data.content;
      store.save(this.menu);
      this.$nextTick(() => {  //解决默认高亮不显示bug
        if (document.body.clientWidth > 768) {
          this.$refs.highlight_pc.updateOpened();
          this.$refs.highlight_pc.updateActiveName();
        } else {
          this.$refs.highlight_phone.updateOpened();
          this.$refs.highlight_phone.updateActiveName();
        }
      })
    }).catch(err => {
      console.log(err);
    });

    this.menuHighlight();
  },
  methods: {
    /*点击logo区回到首页*/
    toHome () {
      this.$router.push({ name: 'home' });
      this.$router.go(0);
    },

    /*点击菜单跳转到相应页面*/
    toPage (route) {
      if (route) {
        if (route.slice(0, 4) == "http") {
          window.open("http://member.tianxia120.com", "_blank")
          return;
        }
        this.phoneMenu = false;
        if (JSON.stringify(this.$route.params) != '{}') {
          top.window.location = this.currUrl.tempUrl + '/#/' + route;
          this.$router.go(0);
        } else {
          this.$router.push(route);
        }
        this.reload();
      } else {
        this.$Message.error('地址不正确');
      }
    },

    /*跳转页面及刷新页面菜单高亮*/
    menuHighlight () {
      let _path;  //url中#后面的地址

      if (this.$route.matched.length == 0) {
        return;
      }

      if (this.$route.matched.length == 1) {
        _path = this.$route.matched[0].path;  //一级菜单
      } else {
        _path = this.$route.matched[1].path;  //子菜单
      }
      _path = _path.substring(_path.lastIndexOf('\/') + 1, _path.length);  //去掉url中/后的地址

      let _menu = store.fetch();
      _menu.forEach(item => {
        if (item.child == null) {
          if (_path == item.route) {
            if (document.body.clientWidth > 768) {
              this.activeMenu_pc = item.id; //一级菜单对应高亮
            } else {
              this.activeMenu_phone = item.id;
            }
          }
        } else {
          let _subMenu = item.child;
          _subMenu.forEach(subItem => {
            if (_path == subItem.route) {
              if (document.body.clientWidth > 768) {
                this.activeMenu_pc = subItem.id;  //子菜单对应高亮
              } else {
                this.activeMenu_phone = subItem.id;
              }
            }
          });
        }
      });
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/common/myHeader.vue